import { searchBoxStyles } from "@insite/content-library/Widgets/MyLists/MyListsSearchBox";
import Search from "@insite/mobius/Icons/Search";
import { listStyles } from "@insite/content-library/Widgets/MyLists/MyListsList";
import { paginationStyles } from "@insite/content-library/Widgets/MyLists/MyListsPagination";
import { productListFilterAccordionSectionStyles } from "@insite/content-library/Widgets/ProductList/ProductListFilterAccordionSection";
import { GridOffset, GridWrapper } from "@insite/mobius/GridContainer";
import { css } from "styled-components";
import getColor from "@insite/mobius/utilities/getColor";
import { wishListCardStyles } from "@insite/content-library/Components/WishListCard";
import { headerStyles } from "@insite/content-library/Widgets/MyListsDetails/MyListsDetailsHeader";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { myListsDetailsOptionsStyles } from "@insite/content-library/Widgets/MyListsDetails/MyListDetailsPagination";
import { createListButtonStyles } from "@insite/content-library/Widgets/MyLists/MyListsCreateListButton";
import { productListStyles } from "@insite/content-library/Widgets/MyListsDetails/MyListsDetailsProductList";
import { InputStyle } from "@insite/mobius/TextField";

productListStyles.sortOrderTextField = {
    labelPosition: "top",
    labelProps: {
        size: 9,
        transform: "uppercase",
        css: css`
                min-height: auto;
                text-align: center;
            `,
    },
    cssOverrides: {
        formInputWrapper: css`
                input[type="number"]::-webkit-outer-spin-button,
                input[type="number"]::-webkit-inner-spin-button {
                    /* ISC-11023 deal with this. */
                    /* stylelint-disable-next-line */
                    -webkit-appearance: none;
                    margin: 0;
                }
            `,
        formField: css`
                margin-top: 10px;
            `,
        inputSelect: css`
                text-align: center;
                /* ISC-11023 deal with this. */
                /* stylelint-disable-next-line */
                -moz-appearance: textfield;
                &:focus, &:focus-within{
                    border: 2px solid ${getColor("primary")} !important;
                }
            `,
    },
}

createListButtonStyles.createListButton = {
    variant: "primary",
}

headerStyles.infoGridItem = {
    width: 12,
    css: css`
        align-items: flex-end;
        >${TypographyStyle}{
            color: ${getColor("secondary")};
        }
        @media print {
            justify-content: flex-start;
            flex-direction: row !important;
        }
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    null,
                    css`
                        flex-direction: column;
                    `,
                    null,
                    null,
                    css`
                        justify-content: flex-start;
                    `,
                ],
                "max",
            )}
    `,
}

wishListCardStyles.sharingStatus = {
    statusText: {
        css: css`
        color: ${getColor("secondary")};
        `
    }
}

wishListCardStyles.actionAddToCartButton = {
    variant: "primary",
    css: css`
        white-space: nowrap;
        width: 100%;
        padding: 0 10px;
    `,
}

wishListCardStyles.lastUpdatedText = {
    css: css`
    color: ${getColor("secondary")};
    `
}

searchBoxStyles.search = {
    css: css`
    padding: 12px 35px 12px 10px !important;
    &:focus{
        padding: 12px 35px 12px 10px !important;
    }
    `,
    iconProps: { src: Search },
}

listStyles.cardList = {
    gridContainer: {
        css: css`
            > ${GridOffset} {
                width: 100%;
                margin: 0;
                > div[class^="sc"] {
                    border-bottom: none;
                    border: 1px solid ${getColor("common.border")};
                    margin-bottom: 15px;
                }
            }
        `,
    },
};
paginationStyles.wrapper = {
    css: css`
        padding: 0px 0px 20px;
    `,
};
productListFilterAccordionSectionStyles.accordionSection = {
    panelProps: {
        css: css`
            overflow-y: auto;
            overflow-x: hidden;
            max-height: 350px;
        `,
    },
    titleTypographyProps: {
        css: css`
            font-size: 1rem !important;
        `,
    },
};

myListsDetailsOptionsStyles.paginationGridItem = {
    width: 12,
    css: css`
        justify-content: flex-end;
        padding-right: 0px;
    `,
}